import React, { useState } from "react";

import QuickCaptureModal from "./QuickCaptureModal";

export default function QuickCaptureBtn(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const {
    autoSubmitInitialText, children, className, collectionsUrl, demoEntries, entriesUrl,
    importsUrl, initialText, isPro, isSignedIn, onOpen, signInUrl, signUpUrl, style,
    targetLanguageEnglishName, targetLanguageIso, targetLanguageName, text, title
  } = props;

  return (
    <>
      <button
        className={className || "btn btn-success"}
        onClick={() => {
          if(onOpen) onOpen();
          setModalVisible(true);
        }}
        style={style}
        title={title || "Quick Capture"}
        type="button"
      >
        {/* children lets a caller supply its own trigger content - the mobile
            bottom nav needs a stacked icon-over-label item, not a button. */}
        {children || (
          <>
            <span className="glyphicon glyphicon-flash"></span>
            {text === false ? "" : (text || " Quick Capture")}
          </>
        )}
      </button>
      {modalVisible && (
        <QuickCaptureModal
          autoSubmitInitialText={autoSubmitInitialText}
          collectionsUrl={collectionsUrl}
          demoEntries={demoEntries}
          entriesUrl={entriesUrl}
          importsUrl={importsUrl}
          initialText={initialText}
          isPro={isPro}
          // Optional: with these, a signed out visitor gets the sign up card and the
          // demo rather than the Pro promo. See QuickCapturePanel.
          isSignedIn={isSignedIn}
          onHidden={() => setModalVisible(false)}
          signInUrl={signInUrl}
          signUpUrl={signUpUrl}
          targetLanguageEnglishName={targetLanguageEnglishName}
          targetLanguageIso={targetLanguageIso}
          targetLanguageName={targetLanguageName}
        />
      )}
    </>
  );
}
